export const zipMask = (value: string) => {
  const v = value.replace(/\D/g, '').slice(0, 9) // 5 + 4 digits
  const parts = []

  if (v.length > 0) parts.push(v.slice(0, 5))
  if (v.length > 5) parts.push('-' + v.slice(5, 9))

  return parts.join('')
}

export const phoneMask = (value: string) => {
  const v = value.replace(/\D/g, '').slice(0, 10) // max 10 digits
  const parts = []

  if (v.length > 0) parts.push('(' + v.slice(0, 3))
  if (v.length >= 4) parts.push(') ' + v.slice(3, 6))
  if (v.length >= 7) parts.push('-' + v.slice(6, 10))

  return parts.join('')
}

export const creditCardMask = (value: string) => {
  const v = value.replace(/\D/g, '').slice(0, 16) // Allow only 16 digits max
  const parts = []

  for (let i = 0; i < v.length; i += 4) {
    parts.push(v.slice(i, i + 4))
  }

  return parts.join(' ')
}
